import React, { useEffect, useState } from "react";
import "./Style/AssessmentECComplete.css";
import bg from "./Image/blank_background.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loading from "../../Common/Loading";

interface AssessmentData {
  LoggedName: string;
  Message: string;
  LogoClass: string;
  GetStarted: string;
  RedirectUrl: string;
  error?: string;
}

const AssessmentECComplete: React.FC = () => {
  const [data, setData] = useState<AssessmentData | null>(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const reportNo = searchParams.get("ReportNo") || "0";
  const calledFrom = searchParams.get("CalledFrom") || "";

  const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

  useEffect(() => {
    document.title = "English Check Completion";
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestBody = {
          SchoolCode: sessionStorage.getItem("SchoolCode"),
          FamilyCode: sessionStorage.getItem("FamilyCode"),
          Login: sessionStorage.getItem("Login"),
          ReportNo: reportNo,
          CalledFrom: calledFrom,
        };

        const response = await fetch(
          `${apiUrl}assessment-ec-complete/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );

        const result = await response.json();

        if (!response.ok) {
          setData({
            LoggedName: "",
            Message: "",
            LogoClass: "",
            GetStarted: "",
            RedirectUrl: "",
            error:
              result?.error ||
              "Unable to load assessment completion page.",
          });

          return;
        }

        setData(result);
      } catch (err) {
        setData({
          LoggedName: "",
          Message: "",
          LogoClass: "",
          GetStarted: "",
          RedirectUrl: "",
          error: "Error loading assessment completion page.",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiUrl, reportNo, calledFrom]);

  const handleFinishClick = () => {
    if (!data?.RedirectUrl) {
      return;
    }

    let redirectUrl = data.RedirectUrl.trim();

    // Convert ASP.NET "~/..." paths to React absolute paths
    if (redirectUrl.startsWith("~/")) {
      redirectUrl = redirectUrl.substring(1);
    }

    // Ensure the path starts with /
    if (!redirectUrl.startsWith("/")) {
      redirectUrl = `/${redirectUrl}`;
    }

    navigate(redirectUrl);
  };

  if (loading) {
    return (
      <tr>
        <td colSpan={100}>
          <Loading />
        </td>
      </tr>
    );
  }

  if (!data) {
    return <div>Error loading data.</div>;
  }

  if (data.error) {
    return <div>{data.error}</div>;
  }

  return (
    <div
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "absolute",
        width: "100vw",
        height: "100vh",
      }}
    >
      <form
        id="form1T"
        style={{
          backgroundImage: `url(${bg})`,
        }}
      >
        <div id="completion_container">
          <div id="divLoggedName">
            {data.LoggedName}
          </div>
        </div>

        <div id="completion_content_box">
          <div id="completion_content">
            <div id="completion_text_box">

              <p className="completion_title">
                ASSESSMENT COMPLETE!
              </p>

              <p className="completion_text">
                <br />

                <span id="spanText">
                  {data.Message}
                </span>

                <br />
                <br />

                <span
                  id="spanGetStarted"
                  className="completion_orange"
                >
                  {data.GetStarted}
                </span>

                <br />
                <br />
              </p>

              <div id="bok_finish_line"></div>

              <div
                id="buttons_box"
                style={{
                  textAlign: "center",
                }}
              >
                <a
                  id="linkbtnFinish"
                  className="finish_btn1T"
                  onClick={handleFinishClick}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (
                      event.key === "Enter" ||
                      event.key === " "
                    ) {
                      event.preventDefault();
                      handleFinishClick();
                    }
                  }}
                >
                </a>
              </div>

            </div>
          </div>
        </div>

        <div
          id="divLogo"
          className={data.LogoClass}
        ></div>
      </form>
    </div>
  );
};

export default AssessmentECComplete;